// extracted by mini-css-extract-plugin
export default {"section":"page-404_section__C96Ed","title":"page-404_title__hUBf0","titleContainer":"page-404_titleContainer__Xvu7R"};